import Vuex from 'vuex'
import Vue from 'vue'
import { isNil, isEmpty } from 'ramda'
import jwt from 'jsonwebtoken'
import configs from '../configs'
import Queue from './vuex'
import SocketService from '../services/SocketService'
Vue.use(Vuex)

let usuarioToken = window.sessionStorage.getItem('userToken')
let usuarioAvatar = window.sessionStorage.getItem('userAvatar')
let empresaToken = window.sessionStorage.getItem('companyToken')
let empresaLogo = window.sessionStorage.getItem('companyLogo')

jwt.verify(JSON.parse(usuarioToken), configs.JWT_PASSWORD, (err) => {
  if (err) {
    window.sessionStorage.removeItem('userToken')
    usuarioToken = null
    window.sessionStorage.removeItem('userAvatar')
    usuarioAvatar = null
    window.sessionStorage.removeItem('companyToken')
    empresaToken = null
    window.sessionStorage.removeItem('companyLogo')
    empresaLogo = null
    console.error('Sua sessão expirou. \nFaça o login novamente!')
  }
})

jwt.verify(JSON.parse(empresaToken), configs.JWT_PASSWORD, (err) => {
  if (err) {
    window.sessionStorage.removeItem('userToken')
    usuarioToken = null
    window.sessionStorage.removeItem('userAvatar')
    usuarioAvatar = null
    window.sessionStorage.removeItem('companyToken')
    empresaToken = null
    window.sessionStorage.removeItem('companyLogo')
    empresaLogo = null
    console.error('Sua sessão expirou. \nFaça o login novamente!')
  }
})

let auxUsuario = (isNil(usuarioToken) || isEmpty(usuarioToken) || usuarioToken === '') ? {} : jwt.verify(JSON.parse(usuarioToken), configs.JWT_PASSWORD)
auxUsuario.token = JSON.parse(usuarioToken)
let auxUsuarioAvatar = (isNil(usuarioAvatar) || isEmpty(usuarioAvatar) || usuarioAvatar === '') ? null : JSON.parse(usuarioAvatar)
let auxEmpresa = (isNil(empresaToken) || isEmpty(empresaToken) || empresaToken === '') ? {} : jwt.verify(JSON.parse(empresaToken), configs.JWT_PASSWORD)
auxEmpresa.token = JSON.parse(empresaToken)
let auxEmpresaLogo = (isNil(empresaLogo) || isEmpty(empresaLogo) || empresaLogo === '') ? null : JSON.parse(empresaLogo)

const state = {
  usuarioStore: auxUsuario,
  usuarioAvatarStore: auxUsuarioAvatar,
  empresaStore: auxEmpresa,
  empresaLogoStore: auxEmpresaLogo,
  appVersion: process.env.MG_APP_VERSION || '0',
  drawerState: false
}

if (!SocketService.socket.connected && auxUsuario.cpf) {
  SocketService.socket.io.opts.query = {
    userCpf: auxUsuario.cpf, userName: auxUsuario.nome
  }
  SocketService.socket.connect()
}

const mutations = {
  setUsuario (state, value) {
    if (value) {
      window.sessionStorage.setItem('userToken', JSON.stringify(value))
      auxUsuario = jwt.verify(value, configs.JWT_PASSWORD)
      auxUsuario.token = value
      SocketService.socket.io.opts.query = {
        userCpf: auxUsuario.cpf, userName: auxUsuario.nome
      }
      SocketService.socket.connect()
    } else {
      window.sessionStorage.removeItem('userToken')
      auxUsuario = {}
      SocketService.socket.disconnect()
    }
    state.usuarioStore = auxUsuario
  },
  setUsuarioAvatar (state, value) {
    if (typeof value === 'string' && value !== '') {
      window.sessionStorage.setItem('userAvatar', JSON.stringify(value))
      auxUsuarioAvatar = value
    } else {
      window.sessionStorage.removeItem('userAvatar')
      auxUsuarioAvatar = null
    }
    state.usuarioAvatarStore = auxUsuarioAvatar
  },
  setEmpresa (state, value) {
    if (value) {
      window.sessionStorage.setItem('companyToken', JSON.stringify(value))
      auxEmpresa = jwt.verify(value, configs.JWT_PASSWORD)
      auxEmpresa.token = value
    } else {
      window.sessionStorage.removeItem('companyToken')
      auxEmpresa = {}
    }
    state.empresaStore = auxEmpresa
  },
  setEmpresaLogo (state, value) {
    if (typeof value === 'string' && value !== '') {
      window.sessionStorage.setItem('companyLogo', JSON.stringify(value))
      auxEmpresaLogo = value
    } else {
      window.sessionStorage.removeItem('companyLogo')
      auxEmpresaLogo = null
    }
    state.empresaLogoStore = auxEmpresaLogo
  },
  setDrawerState (state, value) {
    state.drawerState = value
  }
}

const actions = {
  getUsuario ({ commit }) {
    commit('getUsuario')
  },
  setUsuario ({ commit }, value) {
    commit('setUsuario', value)
  },
  getUsuarioAvatar ({ commit }) {
    commit('getUsuarioAvatar')
  },
  setUsuarioAvatar ({ commit }, value) {
    commit('setUsuarioAvatar', value)
  },
  getEmpresa ({ commit }) {
    commit('getEmpresa')
  },
  setEmpresa ({ commit }, value) {
    commit('setEmpresa', value)
  },
  getEmpresaLogo ({ commit }) {
    commit('getEmpresaLogo')
  },
  setEmpresaLogo ({ commit }, value) {
    commit('setEmpresaLogo', value)
  },
  getAppVersion ({ commit }) {
    commit('getAppVersion')
  },
  getDrawerState ({ commit }) {
    commit('getDrawerState')
  },
  setDrawerState ({ commit }, value) {
    commit('setDrawerState', value)
  },

  ...Queue.actions
}

const getters = {
  getUsuario () {
    return state.usuarioStore
  },
  getUsuarioAvatar () {
    return state.usuarioAvatarStore
  },
  getEmpresa () {
    return state.empresaStore
  },
  getEmpresaLogo () {
    return state.empresaLogoStore
  },
  getAppVersion () {
    return state.appVersion
  },
  getDrawerState () {
    return state.drawerState
  }
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})
